<div class="pdf-viewer">
	<div class="pdf-viewer__header">
		<div class="pdf-viewer__close-button">
			<button class="btn btn" (click)="onClose()">
				<i class="bi bi-arrow-left"></i>
			</button>
		</div>
		<div class="pdf-viewer__title">{{ title }}</div>
	</div>
	<div class="pdf-viewer__content">
		<iframe
			*ngIf="isWebView; else pdfTemplate"
			[src]="safeWebUrl"
			[title]="title"
			[attr.sandbox]="webViewSandbox"
			referrerpolicy="no-referrer"
			class="pdf-viewer__content__viewer pdf-viewer__content__frame"></iframe>
		<ng-template #pdfTemplate>
			<pdf-viewer
				[src]="pdfUrl"
				[render-text]="false"
				[original-size]="false"
				class="pdf-viewer__content__viewer"></pdf-viewer>
			<div *ngIf="!isPdfViewerVisible" class="text-center mt-5">
				URL del Documento invalido
			</div>
		</ng-template>
	</div>
</div>
